import { useQuery } from '@tanstack/react-query'
import { useChatbotSettingsStore } from 'store/useChatbotSettingsStore'
import { Chatbot } from 'lib/types/generated-types'
import { getBaseUrl } from 'util/getBaseUrl'

const fetchPresignedUrl = async (filename: string | null) => {
  if (!filename || filename === 'outcast-logo.png') return null

  const response = await fetch(
    `${getBaseUrl()}/api/get-signed-download-chat-icon?filename=${filename}`
  )
  const data = await response.json()

  return data.signedUrl
}

export const useChatIconPresignedUrls = (chatbot: Chatbot) => {
  const { setIconPresignedUrl, setBubbleIconPresignedUrl } =
    useChatbotSettingsStore((state) => state)

  const iconQuery = useQuery(
    ['iconPresignedUrl', chatbot?.icon_filename],
    () => fetchPresignedUrl(chatbot?.icon_filename),
    {
      enabled: !!chatbot.icon_filename,
      onSuccess: (url) => setIconPresignedUrl(url),
    }
  )

  const bubbleIconQuery = useQuery(
    ['bubbleIconPresignedUrl', chatbot?.bubble_icon_filename],
    () => fetchPresignedUrl(chatbot?.bubble_icon_filename),
    {
      enabled: !!chatbot.bubble_icon_filename,
      onSuccess: (url) => setBubbleIconPresignedUrl(url),
    }
  )

  return {
    iconLoading: iconQuery.isLoading,
    bubbleIconLoading: bubbleIconQuery.isLoading,
  }
}
